import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

type Props = {
  countryCode: string;
  className?: string;
  title?: string;
};

export const LanguageFlag: React.FC<Props> = ({ countryCode, className, title }) => {
  const Flag = (Flags as Record<string, React.ComponentType<{ title?: string; className?: string }>>)[countryCode];

  if (!Flag) {
    return null;
  }

  return <Flag title={title} className={className} />;
};
